export default __webpack_public_path__ + "static/chingari-logo-1c8c827ff570a008855336f8efcc41db.png";